import { bindClient } from "@spiriidk/utils";
import { queryOptions, skipToken, useQuery } from "@tanstack/react-query";
import { getOperators } from "connect-api/enums/api/get-operators";

import { typedFetchNoImpersonate } from "~/api/typed-fetch";

const operatorsApi = bindClient({ getOperators }, typedFetchNoImpersonate);

const operatorsQueryOptions = {
  list: (enabled: boolean) =>
    queryOptions({
      queryKey: ["operators", "list"] as const,
      queryFn: enabled
        ? ({ signal }) => operatorsApi.getOperators(signal)
        : skipToken,
    }),
};

function useOperators(enabled: boolean) {
  const query = useQuery(operatorsQueryOptions.list(enabled));

  return {
    operators: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}

export { operatorsQueryOptions, useOperators };
